import '@axmit/garwin-api';
import { IRequestSuccess } from 'common/models';

export interface IStockListParams extends Paths.StockControllerList.QueryParameters {}
export interface IStockCollection extends Components.Schemas.StockCollectionDto {}

export interface IStockParams extends Paths.StockControllerGetById.PathParameters, IRequestSuccess {}
export interface IStock extends Components.Schemas.StockDto {}
export interface ICreateStockPayload extends Components.Schemas.CreateStockDto, IRequestSuccess {
  isCentral?: boolean;
}
export interface IUpdateStockPayload extends Components.Schemas.UpdateStockDto, IRequestSuccess {
  isCentral?: boolean;
}
export interface IDeleteStockPayload extends Components.Schemas.DeleteStockDto, IRequestSuccess {}

export interface IStockSchedule extends Components.Schemas.ScheduleStockDto {
  isError?: boolean;
}

export enum EDayOfWeek {
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
  'SUN',
}

export enum EDayOfWeekRu {
  'Понедельник',
  'Вторник',
  'Среда',
  'Четверг',
  'Пятница',
  'Суббота',
  'Воскресенье',
}

export const initialStockSchedules: any[] = [
  { dayOfWeek: 'MON', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'TUE', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'WED', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'THU', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'FRI', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'SAT', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
  { dayOfWeek: 'SUN', isDayOff: false, openTime: undefined, closeTime: undefined, isError: false },
];

export const dayOrder: Record<IStockSchedule['dayOfWeek'], number> = {
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
  SUN: 7,
};
